<template>
  <label
    class="custom-checkbox-wrapper"
    :for="identifier"
  >
    <input
      :id="identifier"
      ref="input"
      v-model="innerValue"
      type="checkbox"
      :value="identifier"
      :indeterminate.prop="indeterminate"
      :disabled="disabled"
    />
    <span class="custom-checkbox-box" />
    <span class="custom-checkbox-label"><slot /></span>
  </label>
</template>

<script>
import VModelCompat from '~/mixins/v_model_compat';

export default {
  name: 'AppCheckbox',
  mixins: [VModelCompat],
  props: {
    modelValue: {
      type: Boolean,
      default: undefined,
    },
    value: {
      type: Boolean,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    identifier: {
      type: String,
      default: undefined,
    },
    indeterminate: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    innerValue: {
      get() {
        return this.modelCompatValue;
      },
      set(val) {
        this.emitModelCompatValue(val);
      },
    },
  },
};
</script>
